import type { JSX } from "react";

import { PasswordInput } from "../composed/password-input";
import { Field, FieldError, FieldLabel } from "../field";
import { cn } from "../lib/utils";
import { useFieldContext } from "./form-context";

type PasswordFieldProps = Omit<React.ComponentProps<"input">, "type"> & {
	label: string | JSX.Element;
	required?: boolean;
	placeholder?: string;
	autoComplete?: string;
};

export function PasswordField({
	className,
	label,
	required,
	placeholder,
	autoComplete,
	...props
}: PasswordFieldProps) {
	const field = useFieldContext<string>();
	const isInvalid = field.store.state.meta.isTouched && !field.store.state.meta.isValid;

	return (
		<Field data-invalid={isInvalid}>
			<div className="flex items-center">
				<FieldLabel htmlFor={field.name}>
					{label}
					{required ? " *" : ""}
				</FieldLabel>
			</div>
			<PasswordInput
				aria-invalid={isInvalid}
				autoComplete={autoComplete}
				className={cn(className)}
				data-slot="input-group-control"
				id={field.name}
				name={field.name}
				onBlur={field.handleBlur}
				onChange={(e) => field.handleChange(e.target.value)}
				placeholder={placeholder}
				value={field.store.state.value}
				{...props}
			/>
			{/* hides browsers password toggles */}
			<style>{`
        .hide-password-toggle::-ms-reveal,
        .hide-password-toggle::-ms-clear {
          visibility: hidden;
          pointer-events: none;
          display: none;
        }
      `}</style>
			{isInvalid && <FieldError errors={field.store.state.meta.errors} />}
		</Field>
	);
}
